import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { getCoinStoreList, getStripeToken, createXsollaTransaction, getCoinStoreListIndia, payUHash, easeBuzzHash, easeBuzzPaymentStatus, ooredooDCBAuthPayment, tamatemplusAuthPayment, tamatemplusPaymentMethods } from "../../../Utilities/controller";
import { func } from "../../../Utilities/logFunc";
import { url } from "../../../Utilities/url";
import Loader from "../../Common/Loader";
import TransactionIcon from '../../../assets/images/recent-transaction-icon.png'
import MyTransactionModal from "./MyTransactionModal";
import PaymentModal from "./PaymentModal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Diamond from "../../../assets/images/diamond-icon.png";
// import Diamond2 from "../../../assets/images/Diamond2.png";
import Diamond2 from "../../../assets/images/purchase-pack-icon.png";
import { useTranslation } from "react-i18next";
import { useProfileDataContext } from "./../ProfileContext";
import getSymbolFromCurrency from "currency-symbol-map";
import EmailVerificationModal from "../EmailVerification/EmailVerificationModal";
import { eventTracking } from "../../../firebaseAnalytics";
import { events } from "../../../Utilities/appEvents";
import PayuModal from "./PayuModal";
import OoredooOtpPopup from "./OoredooOtpPopup";
import PaymentGatewayOptionsPopUp from "../PaymentGatewayOptions/PaymentGatewayOptionsPopUp";
const CoinPack = ({ props, selectedType }) => {

  const [coinList, setCoinList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [showMTM, setShowMTM] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [coinDetails, setCoinDetails] = useState('');
  const [stripeToken, setStripeToken] = useState();
  const { profileData, updateProfileData, liteProfile } = useProfileDataContext();
  let countryObj = JSON.parse(localStorage.getItem("profile"))?.country;
  const [emailVerificationModal, setEmailVerificationModal] = useState(false);
  const [showPayuForm, setShowPayuForm] = useState(false)
  const [selectedItem, setSelecetedItem] = useState(null)
  const [payUData, setPayUData] = useState(null)
  const { t } = useTranslation();
  const [showOtpModel, setShowOtpModel] = useState(false);
  const [ooredooDCBAuthToken, setOoredooDCBAuthToken] = useState(null);
  const [tamatemPlusRes, setTamatemPlusRes] = useState(null);

  const [choosePaymentOption, setchoosePaymentOption] = useState(false);
  const [choosePaymentOptionList, setchoosePaymentOptionList] = useState([
    // { value: "EB", name: "Ease Buzz" },
    { value: "OD", name: "Ooredoo DCB" },
    // { value: "TP", name: "Tamatem Plus" },
  ]);
  const [selectedChoosePaymentOption, setSelectedChoosePaymentOption] = useState(null);

  const [pgState, setpgState] = useState(1)
  const [choosePaymentMethods, setchoosePaymentMethods] = useState(false);
  const [choosePaymentMethodList, setchoosePaymentMethodList] = useState([]);
  const [selectedChoosePaymentMethods, setSelectedChoosePaymentMethods] = useState(null);


  const fetchCoinList = async (pageNo) => {
    setLoading(true);
    try {
      let data = {
        // filter: { coinType: "1" },
        group_id: 1,
        country: countryObj?.code,
        skip: 0,
        limit: 10,
        // sort: "asc",
        // sortBy: "amount",
      };

      const res = await getCoinStoreList(data);
      // console.log(res);
      if (res?.data.success) {
        // console.log()
        setCoinList(res?.data?.items);
        // setTotalPage(res?.data?.totalPages);
        setLoading(false);
      }
      func("coinpack", res);
    } catch (error) {
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
      setLoading(false);
    }
  };

  const loadMoreBtnClick = () => {
    let totalCount = parseInt(page) + 9;
    setPage(totalCount);
    fetchCoinListForIndia(totalCount);
  };

  const fetchCoinListForIndia = async (pageNo) => {
    console.log("pageNo", pageNo);
    setLoading(true);
    try {
      let data = {
        filter: { coinType: "1" },
        skip: pageNo,
        limit: 10,
        sort: "asc",
        sortBy: "amount",
      };

      const res = await getCoinStoreListIndia(data);
      // console.log(res);
      if (res?.data.success) {
        // console.log()
        if (pageNo === 0) {
          setCoinList(res?.data?.list);
        }
        else {
          setCoinList([...coinList, ...res?.data?.list]);
        }
        setTotalPage(res?.data?.count);
        // setTotalPage(res?.data?.totalPages);
        setLoading(false);
      }
      func("coinpack", res);
    } catch (error) {
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedType === "packs-tab") {
      setCoinList([]);
      let totalCount = 0;
      setPage(0);
      // if (localStorage.getItem('country') == '611e04284ac17121fd8b1a54')
      //   fetchCoinListForIndia(totalCount);
      // else
      //   fetchCoinList(1);
      fetchCoinListForIndia(totalCount);
    }
  }, [selectedType]);
  // const onClickCoinStore = async(item) => {
  //   setLoading(true);
  //   try {
  //     let body = {
  //       "coinStore": item._id
  //     }
  //     const res = await getStripeToken(body);
  //     if(res.data.success) {
  //       setStripeToken(res.data.item.clientSecret);
  //       setCoinDetails(item);
  //       setShowPayment(true);
  //       setLoading(false);
  //     } else {
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     // console.log(error)
  //     toast.error(error?.response?.data?.errors[0]?.msg)
  //     setLoading(false);
  //   }
  // }

  const onClickCoinStore = async (item) => {
    if ((liteProfile?.item?.isEmailVerified && liteProfile?.item?.isMobileVerified) || (selectedItem && selectedItem !== null)) {
      setLoading(true);
      try {
        let body = {
          sku: item.sku,
          userCurrency: countryObj?.code,
          // amount: parseInt(amount),
          amount: item?.price?.amount,
          type: 1,
          isMobile: false
        };
        const res = await createXsollaTransaction(body);
        console.group(res.data)
        if (res.data.success) {
          // setStripeToken(res.data.item.clientSecret);
          // setCoinDetails(item);
          // setShowPayment(true);
          let body = {
            coin: item.description,
            sku: item.sku,
            amount: item?.price?.amount,
          };
          localStorage.setItem("xsolla-body", JSON.stringify(body));
          localStorage.setItem("currecySymbol", item?.price?.currency);
          eventTracking(events.Buy_Packs, { GJ_PackID: item._id });
          eventTracking(events.Pay_now, { GJ_PackID: item._id, GJ_PAckAmount: item?.price?.amount });

          setLoading(false);
          let url = `https://secure.xsolla.com/paystation4/?token=${res?.data?.data.token}`;
          window.location.href = url;
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.response?.data?.errors[0]?.msg)
      }
    } else {
      setSelecetedItem(item)
      setEmailVerificationModal(true);
    }

  }

  const onCLickCoinStorePayU = async (item) => {
    // 
    // console.log("item>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",item)
    if ((liteProfile?.item?.isEmailVerified && liteProfile?.item?.isMobileVerified) || (selectedItem && selectedItem !== null)) {
      try {
        let payload = {
          key: process.env.REACT_APP_KEY,
          amount: item?.amount,
          productId: item?._id,
          email: liteProfile?.item?.email,
          phone: liteProfile?.item?.phone,
          productInfo: process.env.REACT_APP_COIN_PRODUCT,
          surl: process.env.REACT_APP_BASE_URL + 'api/webapp/payu/payment-status',
          furl: process.env.REACT_APP_BASE_URL + 'api/webapp/payu/payment-status',
          curl: process.env.REACT_APP_BASE_URL + 'api/webapp/payu/payment-status',
          userId: liteProfile?.item?._id,
          coins: item?.coins,
          description: item?.description,
          platform: "webportal"

        };
        let res = await payUHash(payload);
        if (res?.data?.success && res?.data?.hash && res?.data?.transactionID) {
          // console.log("HASH:::",res?.data?.hash)
          payload = { ...payload, hash: res?.data?.hash, txnid: res?.data?.transactionID }
          setTimeout(() => {
            setPayUData(payload)
            setShowPayuForm(true)
          }, 500)

        } else {
          console.log("HASH:::NOT GET HASH")
        }
      } catch (error) {

      }
    }
    else {
      setSelecetedItem(item)
      setEmailVerificationModal(true);
    }

  }

  const onClickCoinStoreEaseBuss = async (item) => {
    if ((liteProfile?.item?.isEmailVerified && liteProfile?.item?.isMobileVerified) || (selectedItem && selectedItem !== null)) {
      var easebuzzCheckout = new window.EasebuzzCheckout(
        process.env.REACT_APP_EASEBUZZ_API_KEY,
        process.env.REACT_APP_EASEBUZZ_API_MODE
      );

      try {
        let payload = {
          amount: item?.price?.amount || item?.amount,
          productId: item?._id,
          email: liteProfile?.item?.email,
          phone: liteProfile?.item?.phone,
          productInfo: process.env.REACT_APP_COIN_PRODUCT,
          userId: liteProfile?.item?._id,
          firstname: liteProfile?.item?.gamerjiName,
          coins: item?.description || item?.coins,
          description: item?.description,
          platform: "webportal"
        };

        let res = await easeBuzzHash(payload);
        if (res.error) {
          const error = res.error.response.data.data[0];
          toast.error(error.msg);
        } else {
          var options = {
            access_key: res.data.data.accessToken,
            onResponse: (response) => {
              let paymentStatus = "";
              let messageError = "";
              if (response.status === "success") {
                paymentStatus = "SUCCESS";
                messageError = "";
                // toast.success("Your payment was successfully.");
              } else if (response.status === "failure") {
                paymentStatus = "FAILED";
                messageError = "We couldn`t process your payment.";
                // toast.error("We couldn`t process your payment.");
              } else if (response.status === "userCancelled") {
                paymentStatus = "USER_CANCELLED";
                messageError = "You have cancelled your payment process.";
                // toast.error("You have cancelled your payment process.");
              } else {
                paymentStatus = response.status.toUpperCase();
                messageError = "Oh no, your payment failed.";
                // toast.error("Oh no, your payment failed");
              }
              onPurchaseGems(response, paymentStatus, res.data, payload, messageError);
            },
            theme: "#123456",
          };
          // console.log(easebuzzCheckout);
          easebuzzCheckout.initiatePayment(options);
        }

      } catch (error) {

      }
    }
    else {
      setSelecetedItem(item)
      setEmailVerificationModal(true);
    }
  }

  const onPurchaseGems = async (paymentRes, paymentStatus, data, values, messageError) => {
    let res = await easeBuzzPaymentStatus(paymentRes);
    if (res?.data?.success) {
      window.location.href = res?.data?.data
    }
    else {
      // console.log("res?.data",res?.response?.data?.data?.[0]?.msg)
      toast.error(messageError || res?.response?.data?.data?.[0]?.msg);
    }
  };

  const sendRequest = (res) => {
    if (res) {
      let item = selectedItem
      setSelecetedItem(item)
      setEmailVerificationModal(false);
      if (localStorage.getItem('country') == '611e04284ac17121fd8b1a54') {
        // onCLickCoinStorePayU(item)
        onClickCoinStoreEaseBuss(item);
      } else {
        // ooredooDCBInitiatePayment(item);
        setchoosePaymentOption(true)
        // onClickCoinStore(item)
      }
    }
  }

  const onClickCoinStorePack = async (item) => {
    // console.log('onClickCoinStorePack',item)
    if (localStorage.getItem('country') == '611e04284ac17121fd8b1a54') {
      // onCLickCoinStorePayU(item)
      onClickCoinStoreEaseBuss(item);
    } else {
      setSelecetedItem(item)
      setchoosePaymentOption(true)
      // ooredooDCBInitiatePayment(item);
      // onClickCoinStore(item);
    }
  }

   useEffect(() => {
     // console.log(">>>", selectedChoosePaymentOption)
     if (selectedChoosePaymentOption != null) {
       if (selectedChoosePaymentOption.value === "OD") {
         ooredooDCBInitiatePayment(selectedItem);
       } else if (selectedChoosePaymentOption.value === "TP") {
         tamatemPlusInitiatePayment(selectedItem, pgState);
       }
     }
   }, [selectedChoosePaymentMethods]);

  const handlerselectOption = async (selectedChoosePaymentOption) => {
    console.log(">>>", selectedChoosePaymentOption)
    if (selectedChoosePaymentOption != null) {
      if (selectedChoosePaymentOption.value === "OD") {
        ooredooDCBInitiatePayment(selectedItem);
      } else if (selectedChoosePaymentOption.value === "TP") {
        tamatemPlusInitiatePayment(selectedItem, pgState)
      }
    }
  };



  const ooredooDCBInitiatePayment = async (item) => {
    if ((liteProfile?.item?.isEmailVerified && liteProfile?.item?.isMobileVerified) || (selectedItem && selectedItem !== null)) {
      try {
        let payload = {
          amount: item?.price?.amount || item?.amount,
          productId: item?._id || item?.item_id,
          email: liteProfile?.item?.email,
          phone: liteProfile?.item?.phone,
          productInfo: process.env.REACT_APP_COIN_PRODUCT,
          userId: liteProfile?.item?._id,
          firstname: liteProfile?.item?.gamerjiName,
          coins: item?.description || item?.coins,
          description: item?.description,
          platform: "webportal",
          isOneTime: true,
        };

        // set loader
        setLoading(true);

        let res = await ooredooDCBAuthPayment(payload);
        if (res.error) {
          const error = res.error.response.data.data[0];
          toast.error(error.msg);
        } else {
          console.log("res from the ooredooDCBInitiatePayment-->", res);
          /** is responce is successfull */
          if (res?.data?.success) {
            /** otp pop up should be displayed here and set the token data */
            setLoading(false);
            setOoredooDCBAuthToken(res?.data?.data);
            setShowOtpModel(true);
          } else {
            setLoading(false);
            toast.error("Error while making the payment try again later.");
          }
        }
      } catch (error) {
        setLoading(false);
        console.error("Error at ooredooInitiatePayment", error);
      }
    } else {
      setSelecetedItem(item)
      setSelectedChoosePaymentOption(null);
      setEmailVerificationModal(true);
    }
  }

  const tamatemPlusInitiatePayment = async (item, stage) => {
    // console.log((liteProfile?.item?.isEmailVerified && liteProfile?.item?.isMobileVerified), (selectedItem && selectedItem !== null), "condition 1 : tamatemPlusInitiatePayment", liteProfile?.item)

    if ((liteProfile?.item?.isEmailVerified && liteProfile?.item?.isMobileVerified) && (selectedItem && selectedItem !== null)) {
      // console.log('item?.currency', item?.currency)
      if (stage === 1) {
        try {
          let payload = {};
          setLoading(true);
          let res = await tamatemplusPaymentMethods(payload);
          if (res.error) {
            const error = res.error.response.data.data[0];
            toast.error(error.msg);
          } else {
            // console.log("res from the paymetMethods", res?.data);
            if (res?.data?.success) {
              console.log("res from the tamatemplusPaymentMethods-->", res?.data?.data);
              let data = res?.data?.data.map((item) => {
                console.log("item", item)
                return {
                  value: item?.id,
                  name: `${item?.name} ( ${item?.type} )`,
                };
              })
              setchoosePaymentMethodList(data);
              setchoosePaymentMethods(true);
              setpgState(2);
              setLoading(false);
            } else {
              setLoading(false);
              toast.error("Error while making the payment try again later.");
            }
          }
        } catch (error) {
          setLoading(false);
          console.error("Error at ooredooInitiatePayment", error);
        }
      } else if (stage === 2) {
        try {
          let payload = {
            amount: item?.price?.amount || item?.amount,
            productId: item?._id || item?.item_id,
            email: liteProfile?.item?.email,
            phone: liteProfile?.item?.phone,
            productInfo: process.env.REACT_APP_COIN_PRODUCT,
            userId: liteProfile?.item?._id,
            firstname: liteProfile?.item?.gamerjiName,
            coins: item?.description || item?.coins,
            description: item?.description,
            platform: "webportal",
            isOneTime: true,
            "packName": item?.name || "C1",
            "currencyCode": item?.currency?.code || "BHD",
            paymentMethod: selectedChoosePaymentMethods?.value || null,
          };

          // set loader
          setLoading(true);

          let res = await tamatemplusAuthPayment(payload);
          if (res.error) {
            const error = res.error.response.data.data[0];
            toast.error(error.msg);
          } else {
            // console.log("res from the tamatemplusAuthPayment-->", res?.data?.data?.url);
            if (res?.data?.success) {
              localStorage.setItem("purchasedCoin", JSON.stringify(selectedItem));
              setLoading(false);
              setTamatemPlusRes(res?.data?.data)
              if (res?.data?.data?.url) {
                try {
                  window.location.href = res?.data?.data?.url;
                  // Alternative: window.open(res.data.url, '_self');
                } catch (error) {
                  toast.error("Payment Succesfully but Invalid URL Found.");

                }
              }
              // setShowOtpModel(true);
            } else {
              setLoading(false);
              toast.error("Error while making the payment try again later.");
            }
          }
        } catch (error) {
          setLoading(false);
          console.error("Error at ooredooInitiatePayment", error);
        }
      }
    } else {
      setSelecetedItem(item)
      setSelectedChoosePaymentOption(null);
      setEmailVerificationModal(true);

    }
  }

  return (
    <>
      {
        <>
          {coinList?.length > 0 ? (
            <div class="col-12" style={{ marginTop: "3rem" }}>
              <div class="mb-4  d-flex align-items-center justify-content-between">
                <h2 class="h3 bodyBoldFont mb-0">
                  {" "}
                  {t("coin_store.coin_packs")}
                </h2>
                <button
                  className="d11-recenttran"
                  onClick={() => setShowMTM(true)}
                >
                  <img src={TransactionIcon} class="transaction-logo" alt="" />
                  {t("reward_store.my_recent_transactions")}
                </button>
              </div>
              <div class="row g-20 mb-3">
                {coinList.map((item, ind) => (
                  <div class="col-lg-4 col-6 mw-lg-20 col-md-6" key={ind}>
                    <div class="card earncoinCard">
                      <div
                        class="row gap text-center"
                        // style={{height:'100%'}}
                      >
                        <div class="col-12 mt-3 mb-4">
                          <img
                            src={Diamond2}
                            style={{ height: "5.625rem", width: "8.625rem" }}
                            alt=""
                          />
                        </div>
                        <div class="col-12 mb-4">
                          <h6 class="mb-1 h5 text-white d-flex justify-content-center align-items-center">
                            {item?.description
                              ? item?.description
                              : item?.coins}
                            <span class="mx-2">
                              {/* <img src={Diamond} className="icon-30"/> */}
                              <img
                                src={
                                  url.imageUrl +
                                  profileData?.item?.wallet[
                                    profileData?.item?.wallet?.findIndex(
                                      (obj) =>
                                        obj.currencyData?.code == "gp_coin"
                                    )
                                  ]?.currencyData?.img?.default
                                }
                                className="icon-30"
                                alt="Gld"
                              />
                            </span>
                          </h6>
                        </div>
                        <div class="col-12 ">
                          <div class="d-grid px-2">
                            <button
                              class="btn text-white btn-earncoin d-flex align-items-center justify-content-center"
                              onClick={() => {
                                onClickCoinStorePack(item);
                              }}
                            >
                              {item?.price?.amount ? (
                                getSymbolFromCurrency(item?.price?.currency)
                              ) : item?.currency?.code.startsWith("diamond") ||
                                item?.currency?.code.startsWith("coin") ? (
                                <img
                                  src={
                                    url.imageUrl + item.currency?.img?.default
                                  }
                                  className="icon-30"
                                  alt="Gld"
                                />
                              ) : (
                                getSymbolFromCurrency(item?.currency?.code)
                              )}
                              <span className="h4 mb-0 ms-1">
                                {item?.price?.amount
                                  ? item?.price?.amount
                                  : item?.amount}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <></>
          )}
          {coinList?.length < totalPage && (
            <div class="d-flex justify-content-center">
              <button
                class="btn btn-primary col-3 text-center"
                onClick={() => loadMoreBtnClick()}
              >
                {t("tournaments.load_more")}
              </button>
            </div>
          )}
          {/* {showPayment && <PaymentModal {...props} stripeToken={stripeToken} coinDetails={coinDetails} showPayment={showPayment} setShowPayment={() => setShowPayment(false)}/>} */}
          {showMTM && (
            <MyTransactionModal showMTM={showMTM} setShowMTM={setShowMTM} />
          )}
          {emailVerificationModal && (
            <EmailVerificationModal
              emailVerificationModal={emailVerificationModal}
              setEmailVerificationModal={setEmailVerificationModal}
              sendRequest={sendRequest}
              tagMobile={liteProfile?.item?.isMobileVerified ? false : true}
              tagEmail={liteProfile?.item?.isEmailVerified ? false : true}
            />
          )}
          {choosePaymentOption && (
            <PaymentGatewayOptionsPopUp
              handleClose={(type) => {
                if (type === 1) {
                  setchoosePaymentOption(false);
                } else {
                  setchoosePaymentOption(false);
                  setSelectedChoosePaymentOption(null);
                  setchoosePaymentMethods(false);
                  setSelectedChoosePaymentMethods(null);
                  setpgState(1);
                }
              }}
              showbox={choosePaymentOption}
              setSelctedValue={(data) => {
                setSelectedChoosePaymentOption(data);
                handlerselectOption(data);
              }}
              optionList={choosePaymentOptionList}
              selectedOption={selectedChoosePaymentOption}
            />
          )}
          {choosePaymentMethods && (
            <PaymentGatewayOptionsPopUp
              heading="Choose Payment Method"
              handleClose={(type) => {
                if (type === 1) {
                  setchoosePaymentMethods(false);
                } else {
                  setchoosePaymentMethods(false);
                  setSelectedChoosePaymentMethods(null);
                  setpgState(1);
                }
              }}
              showbox={choosePaymentMethods}
              setSelctedValue={setSelectedChoosePaymentMethods}
              optionList={choosePaymentMethodList}
              selectedOption={selectedChoosePaymentMethods}
            />
          )}
        </>
      }
      {isLoading ? <Loader /> : <></>}
      {showPayuForm && (
        <PayuModal
          showPayuForm={showPayuForm}
          setShowPayuForm={setShowPayuForm}
          payload={payUData}
        />
      )}

      {
        <OoredooOtpPopup
          showOtpModel={showOtpModel}
          setShowOtpModel={setShowOtpModel}
          ooredooDCBAuthToken={ooredooDCBAuthToken}
          isRecurring={false}
          setLoading={setLoading}
        />
      }
    </>
  );
};
export default CoinPack;
